var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headControll"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"logo"},[_vm._v("2020版造价计价标准宣贯学习")]),_c('div',{staticClass:"navControll"},[_c('div',{staticClass:"nav",on:{"click":_vm.logout}},[_c('router-link',{staticClass:"router-link-active",attrs:{"to":"/"}},[_vm._v("退出登录")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }